<template>
  <Header></Header>
  <div class="main-height">
    <section id="error" class="mt-4">
      <div class="container-fluid">
        <div v-if="error !== null && error !== ''" class="alert alert-secondary py-2 user-notification px-0" role="alert">
          <div class="d-flex flex-column beta- v px-0 align-items-center">
            <h5 class="mb-0 d-flex"><img class="info-img align-self-center" src="../assets/info.svg" alt="">{{ error }}</h5>
          </div>
        </div>
      </div>
    </section>
    <section id="content">
      <div class="container-fluid">
        <div v-if="isLoading" class="row gy-5">
          <EventItemSkeleton></EventItemSkeleton>
          <template v-for="event in this.eventsList" v-bind:key="event.eventId">
            <EventItemSkeleton></EventItemSkeleton>
          </template>
        </div>
        <div v-else class="row gy-5">
          <template v-for="event in this.eventsList" v-bind:key="event.eventId">
            <EventItem v-bind:event_item="event" v-bind:dynamicData="dynamicData"></EventItem>
          </template>
        </div>
        <!--/row-->
      </div>
      <!--/container-fluid-->
    </section>
    <!--/content-->
  </div>
  <Footer></Footer>
</template>

<script>
import {defineComponent} from 'vue'
import Footer from "@/components/Footer.vue";
import Header from "@/components/Header.vue";
import EventItem from '@/components/EventItem.vue'
import EventItemSkeleton from '@/components/EventItemSkeleton.vue'
import AuthService from "@/services/auth-service";
import UsersService from "@/services/users-service";
import LeagueService from "@/services/league-service";
import UserAgentParser from "@/utils/user-agent-parser";

export default defineComponent({
  name: "Events",
  components: {
    EventItem,
    EventItemSkeleton,
    Footer,
    Header,
  },
  data() {
    return {
      cacheTime: Number(process.env.VUE_APP_CACHE_TIME_MS),
      isLoading: true,
      interval: null,
      eventsList: [],
      userPlan: null,
      userProfile: null,
      planEndDate: '',
      error: null,
      scrolled: false,
      leaguesList: [],
      dynamicData: [],
      isChangedDynamic: false
    }
  },
  methods: {
    goEvents () {
      this.$router.push('/events')
    },
    doAccount() {
      this.$router.push('/account')
    },
    getUserLatest: function () {
      this.checkDynamicData()
      this.loadLeaguesIfNeeded()
      UsersService.getUserLatest().then((newUserLatest) => {
        if (newUserLatest) {
          this.compareUserLatest(newUserLatest)
        }
      })
    },
    compareUserLatest: function (newUserLatest) {
      if (localStorage.getItem('userLatest') && localStorage.getItem('userLatest') !== JSON.stringify(newUserLatest)) {
        const oldUserLatest = JSON.parse(localStorage.getItem('userLatest'))
        // compare user latest
        if (oldUserLatest.loginId !== newUserLatest.loginId) {
          AuthService.signOut().then(() => {
            localStorage.setItem('sessionExpired', "true")
            this.$router.push('/signin')
          })
        }
        if (oldUserLatest.userProfile !== newUserLatest.userProfile
            || oldUserLatest.userPlans !== newUserLatest.userPlans) {
          // check if you already made a request
          if (this.isChangedDynamic) {
            this.isChangedDynamic = false;
          } else {
            // update dynamics because region and quality are stored inside profile
            this.loadDynamicData()
          }
          // update user profile
          UsersService.getUserProfile().then(() => {
            if (localStorage.getItem('userProfile')) this.userProfile = JSON.parse(localStorage.getItem('userProfile'))
            if (localStorage.getItem('userPlan')) this.userPlan = JSON.parse(localStorage.getItem('userPlan'))
            if (!this.userProfile.planActive && !this.userProfile.planStatus) {
              // refunded user, logout user with message
              AuthService.signOut().then(() => {
                localStorage.setItem('planExpired', "true")
                this.$router.push('/signin')
              })
            }
            if (this.userProfile) this.planEndDate = new Date(this.userProfile.planEndDate).toLocaleDateString()
          })
        }
        if (oldUserLatest.payments !== newUserLatest.payments) {
          // update user payments
        }
        if (oldUserLatest.statics !== newUserLatest.statics) {
          UsersService.getUserStaticData()
        }
        if (oldUserLatest.channels !== newUserLatest.channels) {
          this.updateLeagues()
        }
      }

      this.error = newUserLatest.errorText
      localStorage.setItem('userLatest', JSON.stringify(newUserLatest))
    },
    setData() {
      if (localStorage.getItem('userProfile')) this.userProfile = JSON.parse(localStorage.getItem('userProfile'))
      if (localStorage.getItem('userPlan')) this.userPlan = JSON.parse(localStorage.getItem('userPlan'))
      if (this.userProfile && this.userProfile.planEndDate < Date.now() || (this.userPlan && this.userPlan.trial && (this.userProfile.trialOverallTime <= 0 || this.userProfile.trialTodayTime <= 0))) {
        this.$router.push('/plans')
      }
      if (this.userProfile) this.planEndDate = new Date(this.userProfile.planEndDate).toLocaleDateString()
      this.setLeagues()
    },
    setLeagues() {
      if (localStorage.getItem('leagueList')) {
        this.leaguesList = JSON.parse(localStorage.getItem('leagueList'))
        this.eventsList = []
        this.leaguesList.forEach(league => {
          // Check if the leagueId matches
          if (league.application === "procricket") {
            league.events.forEach(event => {
              this.eventsList.push(event);
            });
          }
        });
      }
    },
    updateLeagues() {
      // update leagues
      LeagueService.getLeagueList().then(() => {
        this.setLeagues()
      })
    },
    loadLeaguesIfNeeded() {
      const lastUpdated = Number(localStorage.getItem('leagueListUpdatedTime')) || 0;
      if (!localStorage.getItem('leagueList') || (Date.now() - lastUpdated) > this.cacheTime) {
        this.updateLeagues()
      }
    },
    checkDynamicData() {
      if (sessionStorage.getItem('dynamicData')) {
        if (!JSON.parse(sessionStorage.getItem('dynamicData')).edgeAddress) {
          sessionStorage.removeItem('dynamicData');
        } else {
          this.dynamicData = JSON.parse(sessionStorage.getItem('dynamicData'))
        }
      } else {
        this.isChangedDynamic = true;
        this.loadDynamicData();
      }
    },
    loadDynamicData() {
      UsersService.getDynamicData().then(() => {
        this.dynamicData = JSON.parse(sessionStorage.getItem('dynamicData'))
      })
    },
    handleRefresh() {
      localStorage.setItem("refreshed", "true");
    },
    handleScroll() {
      // Check if the page has been scrolled
      this.scrolled = window.scrollY > 0;
    },
    checkAndroidVersion(){
      UserAgentParser.checkAndroidApp()
          .then(needsUpdate => {
            if (needsUpdate) {
              this.$router.push('/android-update');
            }
          })
          .catch(error => {
            console.error("Error checking Android app:", error);
            // Handle error appropriately
          });
    }
  },
  beforeMount() {
    //This feature is for forcing users to update the Android mobile app, more info in task MA-260
    //this.checkAndroidVersion();
    if (
        localStorage.getItem('userPlan') == null ||
        localStorage.getItem('userProfile') == null ||
        localStorage.getItem('leagueList') == null
    ) {
      AuthService.signOut().then(() => {
        this.$router.push('/signin')
      });
    } else {
      this.getUserLatest();
      this.setData();
      setTimeout(() => {
        this.isLoading = false;
      }, 1000);
    }
  },
  mounted() {
    this.interval = setInterval(function () {
      this.getUserLatest();
    }.bind(this), 30000);

    window.addEventListener('scroll', this.handleScroll);

    // handle refresh in order to load dynamics
    window.addEventListener("beforeunload", this.handleRefresh);
    if (localStorage.getItem("refreshed") === "true") {
      this.updateLeagues();
      this.loadDynamicData();
      localStorage.removeItem("refreshed");
    }
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener("beforeunload", this.handleRefresh);
    clearInterval(this.interval);
  },
})
</script>

<style>
@import '../assets/style.css';
.user-notification {top: 120px;}
.info-img{margin-right: 10px;}
#error .container-fluid{padding: 0 8%;}
</style>